import React from 'react';
import { ErrorType } from 'models/monitoring';
import { MonitoringSchema, useMonitoringErrorTypesDictionary } from 'hooks/monitoring';
// components
import { CommonProps, MultiProps, Option, SelectControl, SingleProps } from 'components/Controls/Select';

type Props =
  Partial<Omit<CommonProps<string>, 'options'>>
  & (SingleProps<string> | MultiProps<string>)
  & {
    filter?: (errorType: ErrorType) => boolean;
    schema?: MonitoringSchema;
  }

export const IncidentErrorTypeSelect = (props: Props): JSX.Element => {
  const { isLoading, errorTypes } = useMonitoringErrorTypesDictionary(props.schema ?? 'global');
  const filterCallback = props.filter ?? (() => (true));

  const options: Option<string>[] =
    errorTypes
      .filter(filterCallback)
      .map(errorType => ({
        value: errorType.id,
        label: errorType.name,
      }));

  return (
    <SelectControl
      name="errorType"
      label="Error Type"
      closeMenuOnSelect={ !props.isMulti }
      { ...props }
      options={ options }
      isLoading={ isLoading }
      checkSelected={ !isLoading }
      isDisabled={ !options.length || props.isDisabled }
    />
  );
};
